import React from 'react'
import Signup from "./sign-page/Signup"
const Signupsec = () => {
  return (
   <Signup/>
  )
}

export default Signupsec